<template>
  <div class="pagination-module">
    <div class="flex flex-between">

      <div class="showing">
        <label>Showing</label>
        <select v-model="showing" @change="changePerPage()">
          <option value="16">16</option>
          <option value="24">24</option>
          <option value="32">32</option>
          <option value="48">48</option>
        </select>
        <label> of {{ pagination.total }} products</label>
      </div>

      <div class="pages">
        <ul>
          <li
            v-if="showPreviousPage()"
            @click="setPage(pagination.current_page - 1)"
            class="prev"
          >
            <a>
              <span class="icon-angle-left"></span>
            </a>
          </li>
            
          <li
            v-for="page in pages"
            :key="page.label"
            @click="setPage(page.label)"
            :class="isActive(page.label)"
          >
            <a>{{ page.label }}</a>
          </li>
        
          <li
            v-if="showLastPage()"
            @click="setPage(pagination.current_page + 1)"
            class="next"
          >
            <a>
              <span class="icon-angle-right"></span>
            </a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    pagination: Object
  },
  
  data () {
    return {
      limit: 7,
      showing: 16
    }
  },
  
  computed: {
    pages () {
      let pages = []
      for (let i = 1; i < this.pagination.last_page; i++) {
        if (this.paginatorFrom() < i && i < this.paginatorTo()) {
          pages.push({
            label: i            
          })
        }
      }      
    
      return pages
    }
  },
  
  methods: {
    changePerPage () {
      let val = parseInt(this.showing)
      this.$emit('setPerPage', val)
    },

    paginatorFrom () {
        
      let half_total_links = Math.floor(this.limit / 2)
      let from = this.pagination.current_page - half_total_links;
      
      if (this.pagination.last_page - this.pagination.current_page < half_total_links) {
        from -= half_total_links - (this.pagination.last_page - this.pagination.current_page) - 1
      }

      return from
    },

    paginatorTo () {
      let half_total_links = Math.floor(this.limit / 2);
      let to = this.pagination.current_page + half_total_links;
      
      if (this.pagination.current_page < half_total_links) {
        to += half_total_links - this.pagination.current_page
      }

      return to
    },
    
    isActive (page) {
      if (this.pagination.current_page === page) {
        return { active: true }
      }
      return { active: false }
    },
    
    showPreviousPage () {
      if (parseInt(this.pagination.current_page) > 1) {
        return true
      }
      return false      
    },
    
    showLastPage () {
      if (parseInt(this.pagination.current_page) < parseInt(this.pagination.last_page)) {
        return true
      }      
      return false      
    },
    
    setPage (page) {
      this.$emit('setPage', page)
    }
  }  
  
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Pagination.vue